export const AUTH_DEV_SESSION_STORAGE_KEY = 'sweet-dev-mock-session';
export const AUTH_FIRST_LOGIN_STORAGE_KEY = 'sweet-first-login';
